import React, { useState } from "react";
import Layout from "../../Layout/index";

const HealthPlans = () => {
  const [billing, setBilling] = useState("monthly");

  const plans = {
    monthly: [
      {
        name: "Basic Care",
        price: "₹999",
        desc: "Essential coverage for individuals.",
        features: [
          "Unlimited Doctor Consultations",
          "Discounted Lab Tests",
          "24/7 Phone Support",
        ],
      },
      {
        name: "Family Care",
        price: "₹2499",
        desc: "Comprehensive plan for families.",
        features: [
          "Quarterly Family Checkups",
          "Specialist Consultations",
          "Discounted Medicines",
          "Free Ambulance Service",
        ],
        popular: true,
      },
      {
        name: "Premium Care",
        price: "₹4999",
        desc: "Healthcare with priority services.",
        features: [
          "Personal Health Manager",
          "Unlimited Specialists",
          "Premium Hospital Access",
          "Annual Master Health Check",
        ],
      },
    ],
    annual: [
      {
        name: "Basic Care",
        price: "₹9,999",
        desc: "Save 2 months with annual plan.",
        features: [
          "Unlimited Doctor Consultations",
          "Discounted Lab Tests",
          "24/7 Phone Support",
        ],
      },
      {
        name: "Family Care",
        price: "₹24,999",
        desc: "Best value for families.",
        features: [
          "Quarterly Family Checkups",
          "Specialist Consultations",
          "Discounted Medicines",
          "Free Ambulance Service",
        ],
        popular: true,
      },
      {
        name: "Premium Care",
        price: "₹49,999",
        desc: "Priority care for annual members.",
        features: [
          "Personal Health Manager",
          "Unlimited Specialists",
          "Premium Hospital Access",
          "Annual Master Health Check",
        ],
      },
    ],
  };

  return (
    <Layout>
      <div className="py-12 text-center">
        <p className="text-sm font-medium font-sans bg-gradient-to-r from-blue-500 to-cyan-500 bg-clip-text text-transparent">
          Plans and Pricing
        </p>
        <h2 className="mt-1 text-3xl font-inter font-bold text-gray-900">
          Choose Your Plans
        </h2>
        <div className="flex justify-center">
          <div className="mt-6 w-48 rounded-lg border flex justify-between font-sans">
            <button
              onClick={() => setBilling("monthly")}
              className={`px-4 py-1 rounded-lg font-medium transition ${
                billing === "monthly"
                  ? "bg-gradient-to-r from-blue-500 to-cyan-500 text-white"
                  : "text-gray-600 hover:bg-gray-200"
              }`}
            >
              Monthly
            </button>
            <button
              onClick={() => setBilling("annual")}
              className={`px-4 py-1 rounded-lg font-medium transition ${
                billing === "annual"
                  ? "bg-gradient-to-r from-blue-500 to-cyan-500 text-white"
                  : "text-gray-600 hover:bg-gray-200"
              }`}
            >
              Annual
            </button>
          </div>
        </div>
        {/* Cards */}
        <div className="mt-10 flex flex-row md:flex-row justify-center gap-6">
          {plans[billing].map((plan, idx) => (
            <div
              key={plan.name}
              className={`relative w-80 rounded-2xl transition transform hover:-translate-y-2 shadow-xl border duration-300 ${
                plan.popular
                  ? "bg-gradient-to-b from-slate-950 font-sans to-slate-900 text-white border-2 border-blue-500"
                  : "bg-white text-gray-900"
              }`}
            >
              {/* Most Popular Badge */}
              {plan.popular && (
                <div className="font-inter absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-blue-500 to-cyan-500 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md">
                  Most Popular
                </div>
              )}

              <div className="p-6 flex flex-col h-full">
                {/* Plan Info */}
                <h3
                  className={`text-sm font-semibold font-sans uppercase tracking-wide ${
                    plan.popular ? "text-blue-400" : "text-blue-600"
                  }`}
                >
                  {plan.name}
                </h3>
                <div className="mt-2 flex items-baseline justify-center gap-2">
                  <span className="text-3xl font-bold">{plan.price}</span>
                  <span className="text-sm text-gray-400">
                    /{billing === "monthly" ? "month" : "year"}
                  </span>
                </div>
                <p
                  className={`mt-2 text-sm font-sans ${
                    plan.popular ? "text-gray-300" : "text-gray-500"
                  }`}
                >
                  {plan.desc}
                </p>

                {/* Features */}
                <ul className="mt-6 space-y-3 text-left font-inter">
                  {plan.features.map((feature) => (
                    <li key={feature} className="flex items-start gap-2">
                      <span className="text-blue-500">✔</span>
                      <span
                        className={`text-sm ${
                          plan.popular ? "text-gray-200" : "text-gray-700"
                        }`}
                      >
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>

                {/* Button */}
                <button
                  className={`mt-8 w-full rounded-xl px-4 py-3 font-semibold transition ${
                    plan.popular
                      ? "bg-gradient-to-r from-blue-500 to-cyan-500 text-white hover:bg-blue-600"
                      : "bg-gray-200 text-gray-900 hover:bg-gradient-to-r from-blue-500 to-cyan-500 hover:text-white"
                  }`}
                >
                  Choose Plan
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default HealthPlans;
